import {
  type ColumnFiltersState,
  type OnChangeFn,
  type SortingState,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import type { Investment } from '../_investment_types/investment.types'
import { columns } from './columns'

type InvestmentsSorting = {
  columnFilters: ColumnFiltersState
  onColumnFiltersChange: OnChangeFn<ColumnFiltersState>
  sorting: SortingState
  onSortingChange: OnChangeFn<SortingState>
}

function useInvestmentsTable(
  data: Array<Investment>,
  {
    columnFilters,
    sorting,
    onColumnFiltersChange,
    onSortingChange,
  }: InvestmentsSorting
) {
  return useReactTable({
    data,
    columns,
    state: { columnFilters, sorting },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    onColumnFiltersChange,
    onSortingChange,
    getCoreRowModel: getCoreRowModel(),
  })
}

export { useInvestmentsTable }
